import { getTranslationCatalog } from "./utils/_i18n.js";

export const tilesJS = (fn) => {
  getTranslationCatalog().then(function (trad) {
    fn(trad);

    // browser has MutationObserver support
    // if (window.MutationObserver) {
    //   // https://developer.mozilla.org/it/docs/Web/API/MutationObserver
    //   // Select the node that will be observed for mutations
    //   $(".pat-tiles-management").each(function () {
    //     // Options for the observer (which mutations to observe)
    //     var config = { attributes: false, childList: true, subtree: true };

    //     // Callback function to execute when mutations are observed
    //     var callback = function (mutationsList) {
    //       mutationsList.forEach(function (mutation) {
    //         if (mutation.type == "childList") {
    //           fn(trad);
    //           console.log("tilesJS 2 ");
    //         }
    //       });
    //     };

    //     // Create an observer instance linked to the callback function
    //     var observer = new MutationObserver(callback);

    //     // Start observing the target node for configured mutations
    //     observer.observe(this, config);
    //   });
    // } else {
    // browser has no MutationObserver support
    $(".pat-tiles-management").on("rtTilesLoaded", function () {
      fn(trad);
    });
    //}
  });
};
